import { candidateVerificationService as service } from '../services/candidate-verification.service';
import type { CreateVerificationRequest } from '@/features/verifications/types/verification.types';

export interface VerificationActions {
  create: (request: CreateVerificationRequest) => Promise<unknown>;
  remove: (verificationId: string) => Promise<unknown>;
  send: (verificationId: string) => Promise<unknown>;
}

const authenticatedActions = (experienceId: string): VerificationActions => ({
  create: (request) => service.create(experienceId, request),
  remove: (verificationId) => service.delete(experienceId, verificationId),
  send: (verificationId) => service.send(experienceId, verificationId),
});

const anonymousActions = (shareId: string, experienceId: string): VerificationActions => ({
  create: (request) => service.createByShareId(shareId, experienceId, request),
  remove: (verificationId) => service.deleteByShareId(shareId, experienceId, verificationId),
  send: (verificationId) => service.sendByShareId(shareId, experienceId, verificationId),
});

export function verificationActions(
  isAnonymous: boolean,
  shareId: string | null,
  experienceId: string
): VerificationActions {
  return isAnonymous
    ? anonymousActions(shareId!, experienceId)
    : authenticatedActions(experienceId);
}
